var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-headful',{attrs:{"title":"Browse by Categories - Where does it Go?"}}),_c('ul',{staticClass:"nestedNav"},_vm._l((_vm.nav),function(item){return _c('nested-nav',{key:item.name,attrs:{"item":item}})}),1),_c('Feedback')],1)}
var staticRenderFns = []

export { render, staticRenderFns }